import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css'
import Vant from 'vant'
import './assets/themify-icons/themify-icons.css'
import Axios from "axios";
import './assets/globle.css'

Vue.config.productionTip = false
Vue.use(Vant);

Vue.prototype.$axios = Axios;
Axios.defaults.baseURL = 'api/';

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
